goog.provide('el8.appshared.dialog.reassignReviewUser');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appshared.dialog.reassignReviewUser');
goog.require('el8.appservice.notifier');
goog.require('el8.data.practiceUsers');


el8.appshared.dialog.reassignReviewUser = (function() {

    var report = null;
    var patientId = null;
    var patientName = null;
    var successCb = null;
    var cancelCb = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Assign Report to Other User',
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.appshared.dialog.reassignReviewUser.content({
                isBatchMode: (el8Globals['APP'] === 'home'),
                users: el8.data.practiceUsers.getPhysicianUsers().filter(function(a) { 
                    return a.id !== el8.data.currUser.getId(); 
                })
            });
        }
    });
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'user',
                selector: ':input[name="user"]'
            }
        ]
    });
    form.addButton('assign', 'Assign', function(_form) {
        var url = '';
        if (patientId) {
            el8.appservice.notifier.notify('Re-assigning patient\'s reports...');
            url = el8.service.urls.get('assignBulkReports', [patientId]);
        } else if (report) {
            el8.appservice.notifier.notify('Re-assigning report...');
            url = el8.service.urls.get('assignReport', [report]);
        }
        var newUserId = _form.getVal('user');
        $.el8_ajax({
            url: url,
            type: 'POST',
            data: {'data': JSON.stringify({'physician_user_id': newUserId})},
            success: function() {
                if (patientId) {
                    el8.appservice.notifier.notify('Patient\'s reports successfully re-assigned.');
                } else {
                    el8.appservice.notifier.notify('Report successfully re-assigned');
                }
                if (report) { report.setReviewUserId(newUserId); }
                if (successCb) { successCb(); }
                that.hide();
            }
        });
    }, true);
    form.addCancelButton(function() {
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {

        spec = spec || {};
        patientId = spec.patientId || null;
        patientName = spec.patientName || null;
        successCb = spec.successCb || null;
        cancelCb = spec.cancelCb || null;
        report = spec.report || null;

        super_show.call(that);
        if (patientName) {
            $('.patient-name', that.getContentElt()).text(patientName);
        } else {
            $('.patient-name', that.getContentElt()).text('this patient');
        }
        if (report) {
            $('.report-description', that.getContentElt()).text(report.getNoteSummary());
            if (report.getReviewUserName()) {
                $('.review-user-name', that.getContentElt()).text(report.getReviewUserName());
            } else {
                $('.review-user-name', that.getContentElt()).text('<no user assigned>');
            }
        }
        $('.user-dropdown-box', that.getContentElt()).html(
            el8.template.appshared.dialog.reassignReviewUser.userDropdown({
                users: el8.data.practiceUsers.getPhysicianUsersInWorkspace().filter(function(a) { 
                    var exceptId = (report ? report.getReviewUserId() : null);
                    return (a.id !== exceptId) && !a.isElationStaff;
                })
            })
        );
        that.adjustHeight();
    };

    var super_hide = that.hide;
    that.hide = function() {
        if (cancelCb) { cancelCb(); }
        patientId = null;
        patientName = null;
        successCb = null;
        cancelCb = null;
        report = null;
        super_hide.call(that);
        $('.patient-name', that.getContentElt()).empty();
        $('.report-description', that.getContentElt()).empty();
        $('.review-user-name', that.getContentElt()).empty();
    };

    return that;

})();


